import React from 'react';

import { FooterLinkDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

import { LINK_LABEL, PROFILE_LABEL, TEXT_LABEL } from '../types';
import { mapToReadableProfile } from '../utils/mappers';

interface ModalDetailsProps {
  footerLink: FooterLinkDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  footerLink,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <BaseModal
      width={BaseModalWidthUtils.xLargeWidth}
      isVisible={visible}
      closeModal={close}
      className="modalDetails"
    >
      <>
        <FieldDisplay
          label={LABEL_ID_CORRELATION}
          value={footerLink.idCorrelation}
        />
        <FieldDisplay label={LINK_LABEL} value={footerLink.link} />
        <FieldDisplay label={TEXT_LABEL} value={footerLink.text} />
        <FieldDisplay
          label={PROFILE_LABEL}
          value={mapToReadableProfile(footerLink.profile)}
        />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
